import React from 'react';
import PropTypes from 'prop-types';
import picturefill from 'picturefill';
import LazyLoad from 'react-lazyload';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import 'picturefill/src/plugins/mutation/pf.mutation';
import { closeImagePlayer, openImagePlayer, setImagePlayerImages, setInitialIndex } from '../../../Base/Actions';

// import assets
import './picture.scss';
import '../../../../assets/icons/Lenspire_Icon_ZoomIn.svg';


class Picture extends React.Component {
  constructor(props) {
    super(props);

    this.setImagePlayerImages = this.setImagePlayerImages.bind(this);
  }

  componentDidUpdate() {
    picturefill();
  }

  setImagePlayerImages(index) {
    this.props.openImagePlayer();
    this.props.setImagePlayerImages(this.props.imageCollection);
    this.props.setInitialIndex(index);
  }

  render() {
    let className = this.props.class;
    if (this.props.imageCollection.length > 0) {
      className += ' m-picture--clickable';
    }
    if (this.props.disableLL) {
      return (
        <div
          onClick={() => {
            if (!this.props.disableZoom) {
              this.setImagePlayerImages(this.props.collectionIndex);
            }
          }}
          role={'button'}
          tabIndex={-1}
        >
          <picture className={`m-picture ${className}`}>
            <source srcSet={this.props.src.xxl} media="(min-width: 2560px)" />
            <source srcSet={this.props.src.xl} media="(min-width: 1920px)" />
            <source srcSet={this.props.src.lg} media="(min-width: 1025px)" />
            <source srcSet={this.props.src.md} media="(min-width: 768px)" />
            <source srcSet={this.props.src.sm} media="(min-width: 0px)" />
            <img srcSet={this.props.src.default} alt={this.props.alt} draggable={this.props.draggable} />
            {(() => {
              if (this.props.imageCollection && !this.props.disableZoom) {
                return (<div className={'m-zoomIn'}>
                  <svg>
                    <use xlinkHref="#Lenspire_Icon_ZoomIn" />
                  </svg>
                </div>);
              }
              return null;
            })()}
          </picture>
        </div>
      );
    }
    return (
      <LazyLoad once offset={0} height={200}>
        <div
          onClick={() => {
            if (!this.props.disableZoom) {
              this.setImagePlayerImages(this.props.collectionIndex);
            }
          }}
          role={'button'}
          tabIndex={-1}
        >
          <picture className={`m-picture ${className}`}>
            <source srcSet={this.props.src.xxl} media="(min-width: 2560px)" />
            <source srcSet={this.props.src.xl} media="(min-width: 1920px)" />
            <source srcSet={this.props.src.lg} media="(min-width: 1025px)" />
            <source srcSet={this.props.src.md} media="(min-width: 768px)" />
            <source srcSet={this.props.src.sm} media="(min-width: 0px)" />
            <img srcSet={this.props.src.default} alt={this.props.alt} draggable={this.props.draggable} />
            {(() => {
              if (this.props.imageCollection && !this.props.disableZoom) {
                return (<div className={'m-zoomIn'}>
                  <svg>
                    <use xlinkHref="#Lenspire_Icon_ZoomIn" />
                  </svg>
                </div>);
              }
              return null;
            })()}
          </picture>
        </div>
      </LazyLoad>
    );
  }
}

Picture.propTypes = {
  class: PropTypes.string,
  src: PropTypes.shape({
    sm: PropTypes.string,
    md: PropTypes.string,
    lg: PropTypes.string,
    xl: PropTypes.string,
    xxl: PropTypes.string,
    default: PropTypes.string,
  }),
  imageCollection: PropTypes.arrayOf(PropTypes.shape()),
  alt: PropTypes.string,
  draggable: PropTypes.bool,
  disableLL: PropTypes.bool,
  disableZoom: PropTypes.bool,
  openImagePlayer: PropTypes.func.isRequired,
  setImagePlayerImages: PropTypes.func.isRequired,
  setInitialIndex: PropTypes.func.isRequired,
  collectionIndex: PropTypes.number,
};

Picture.defaultProps = {
  class: '',
  src: {
    sm: '',
    md: '',
    lg: '',
    xl: '',
    xxl: '',
    default: '',
  },
  imageCollection: [],
  alt: '',
  disableLL: false,
  disableZoom: false,
  draggable: true,
  collectionIndex: 0,
};

function mapStateToProps(state) {
  return {
    ...state.imagePlayerState,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ closeImagePlayer, openImagePlayer, setImagePlayerImages, setInitialIndex }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Picture);



// WEBPACK FOOTER //
// ./frontend/js/Components/Util/Picture/Picture.jsx